import { getApiUrl } from './apiUrl';

/**
 * Retourne l'URL complète pour une image stockée sur le backend (uploads).
 * - data: et http(s): sont renvoyés tels quels.
 * - Les chemins relatifs (/uploads/...) sont préfixés par l'URL de l'API pour éviter
 *   les requêtes vers le mauvais domaine (surtout en prod quand front et API sont séparés).
 */
export function getImageUrl(url: string | null | undefined): string {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('data:')) return trimmed;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  const base = getApiUrl();
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${base.replace(/\/$/, '')}${path}`;
}
